<template>
  <div>
    <div v-if="open" class="fixed inset-0 z-50 bg-black bg-opacity-50" @click="onBackdrop" />
    <div
      v-if="open"
      class="bg-background fixed top-1/2 left-1/2 z-50 grid w-11/12 transform -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg"
      :class="contentClass"
      :style="contentStyle"
      role="dialog"
      aria-modal="true"
    >
      <div class="flex items-start justify-between gap-4">
        <div class="flex-1">
          <slot name="header" />
        </div>
        <button
          v-if="showClose"
          class="ring-offset-background focus:ring-ring absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-none"
          type="button"
          @click="$emit('update:open', false)"
        >
          <span class="sr-only">Close</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    open: { type: Boolean, default: false },
    showClose: { type: Boolean, default: true },
    closeOnBackdrop: { type: Boolean, default: true },
    contentClass: { type: String, default: '' },
    contentStyle: { type: Object, default: () => ({}) },
  },
  methods: {
    onBackdrop() {
      if (!this.closeOnBackdrop) return
      this.$emit('update:open', false)
    },
  },
}
</script>

